import { defineStore } from "pinia";
import { ref } from "vue";
import { useAudioStore } from "./AudioStore";
import { useToastStore } from "./ToastStore";
import { useSelectionStore } from "./SelectionStore";

export const useKeyboardEventStore = defineStore('keyboardEvent', () => {

  // --------------------------------------------------------
  // CONSTANTS
  // --------------------------------------------------------

  const audioStore = useAudioStore()
  const toastStore = useToastStore()
  const selectionStore = useSelectionStore()

  // --------------------------------------------------------
  // STATE
  // --------------------------------------------------------

  //0: note add/remove
  //1: note selection
  const clickMode = ref(0)

  // --------------------------------------------------------
  // GETTERS
  // --------------------------------------------------------

  // --------------------------------------------------------
  // ACTIONS
  // --------------------------------------------------------

  // --------------------------------------------------------
  // MISC
  // --------------------------------------------------------

  const handleKeyDown = e => {
    switch (e.key) {
      case ' ':
        e.preventDefault() //temporary
        audioStore.togglePausePlay()
        break
      case 's':
      case 'S':
        if (e.ctrlKey) {
          eventBusPublish({type: 'save'})
          e.preventDefault();
        }
        break
      case 'Tab':
        e.preventDefault();
        break
      case 'Delete':
      case 'Del':
        selectionStore.deleteSelectedNotes()
        break
    }
  }

  const handleKeyUp = e => {
    switch (e.key) {
      case 'Alt':
        e.preventDefault();
        break
      case ' ':
        e.preventDefault();
        break
      case 'Tab':
        clickMode.value = clickMode.value == 0 ? 1 : 0
        toastStore.show(`Changed click mode to "${clickMode.value == 0 ? "Note" : "Select"}"`)
        break
    }

  }

  let eventBusSubscribers = []

  const eventBusSubscribe = (callbackFn) => {
    eventBusSubscribers.push(callbackFn)
  }
  const eventBusUnsubscribe = (callbackFn) => {
    eventBusSubscribers = eventBusSubscribers.filter(e => e != callbackFn)
  }

  const eventBusPublish = (data) => {
    eventBusSubscribers?.forEach(e => e(data))
  }

  document.addEventListener('keydown', handleKeyDown)
  document.addEventListener('keyup', handleKeyUp)

  return {
    eventBusSubscribe,
    eventBusUnsubscribe,
    clickMode,
    handleKeyDown,
    handleKeyUp,
  }
})